import React from "react";
import WhiteIcon from "./images/white-icon.svg";
import OrangeIcon from "./images/orange-icon.svg";
import PropTypes from "prop-types";

const IconSendMsg = ({ type = "orange", ...props }) => {

    const iconMap = {
        white: WhiteIcon,
        orange: OrangeIcon
    };

    return (
        <img src={iconMap[type]} {...props} />
    );
};

IconSendMsg.propTypes = {
    type: PropTypes.string
};

export default IconSendMsg;
